import styled from 'styled-components';
import { Button } from '@salutejs/sdds-insol';
import { useModalStore } from '@/entities/Modal';
import { Typography } from '@/shared/ui/Typography';
import Logo from '@/shared/assets/lk/lkLogo.svg?react';
import { ModalWrapper } from '@/shared/ui/ModalWrapper';
import { useGlobalStore } from '@/entities/GlobalStore';
import { getPreparedTime } from '../lib/getPreparedTime';
import { BUTTON_COLOURS, BUTTON_VIEWS, REASONS } from '../model/data';
import cls from './FormSuccessModal.module.scss';

export const FormSuccessModal = () => {
    const {
        consultationParams: { date, time, reason },
    } = useGlobalStore();
    const { isSuccessFormSentModalOpen, setIsSuccessFormSentModalOpen } = useModalStore();

    const { startHours, endHours } = getPreparedTime({ time });

    const reasonText = REASONS[reason];
    const buttonColour = BUTTON_COLOURS[reason];
    const buttonView = BUTTON_VIEWS[reason];

    const StyledButton = styled(Button)`
        background-color: ${buttonColour};
    `;

    return (
        <ModalWrapper id="formSuccessModal" isOpened={isSuccessFormSentModalOpen} setIsOpened={setIsSuccessFormSentModalOpen}>
            <div className={cls.container}>
                <Logo className={cls.logo} />
                <Typography className={cls.title} as="h5" variant="h5_bold">
                    Спасибо! Ваша заявка отправлена
                </Typography>
                <Typography className={cls.text} as="h5" variant="text_18_gray">
                    <p>Наш менеджер свяжется с вами {date}</p>
                    <p>
                        c {startHours} до {endHours} {reasonText}
                    </p>
                </Typography>
                <Typography as="h5" variant="text_18_gray" />
                <StyledButton
                    size="xl"
                    type="submit"
                    view={buttonView}
                    stretch
                    onClick={() => {
                        setIsSuccessFormSentModalOpen(false);
                    }}
                >
                    <span className="SBSansText">Понятно</span>
                </StyledButton>
            </div>
        </ModalWrapper>
    );
};
